import React from 'react';
import {
    formatAccountState,
    formatBirthdate,
    formatConfirmationState,
    formatGigaBytes,
    formatRole
} from '../../../helpers/FormatHelper';
import {User} from '../../../models/User';
import {useTranslation} from "react-i18next";
import {useLongPress} from "../../../hooks";
import {CheckBox} from "../CheckBox/CheckBox";


interface UsersProps {
    user: User;
    onClick: () => void;
    isChecked?: boolean;
    onCheck?: (isChecked: boolean) => void;
    onContextMenuHandler?: (anchorX: number, anchorY: number) => void;
}

const UsersLong: React.FC<UsersProps> = ({ user, onClick, isChecked, onCheck, onContextMenuHandler }: UsersProps) => {
    const {t} = useTranslation();
    const contextMenuHandler = (event: React.MouseEvent<HTMLTableRowElement>) => {
        if (!onContextMenuHandler) {
            return;
        }
        event.preventDefault();
        onContextMenuHandler(event.clientX, event.clientY);
    };
    // touch: long press opens the context menu (iOS does not fire contextmenu)
    const longPress = useLongPress(onContextMenuHandler);
    return (
        <tr onClick={onCheck ? undefined : onClick} onContextMenu={onContextMenuHandler ? contextMenuHandler : undefined} {...longPress}>
            {onCheck &&
                <td align="center">
                    <CheckBox title={""} value={isChecked ?? false} onChange={onCheck}/>
                </td>
            }
            <td align="center" onClick={onCheck ? onClick : undefined}>{user.email}</td>
            <td align="center" onClick={onCheck ? onClick : undefined}>{formatRole(t, user.role)}</td>
            <td align="center" onClick={onCheck ? onClick : undefined}>{user.name}</td>
            <td align="center" onClick={onCheck ? onClick : undefined}>{formatBirthdate(user.registrationDate)}</td>
            <td align="center" onClick={onCheck ? onClick : undefined}>{formatConfirmationState(t, user.emailConfirmed)}</td>
            <td align="center"
                onClick={onCheck ? onClick : undefined}>{formatGigaBytes(user.usedDiskSpace)} {t("file_size_units_gb")}</td>
            <td align="center" onClick={onCheck ? onClick : undefined}>{formatAccountState(t, user.accountActive)}</td>
        </tr>
        );
}

export default UsersLong;
